const inFlightRequests = new Map();

const normalizeKeyPart = (value) => {
    if (value == null) {
        return '';
    }
    if (Array.isArray(value)) {
        return value.map(normalizeKeyPart).join(',');
    }
    if (value && typeof value === 'object') {
        return JSON.stringify(
            Object.keys(value)
                .sort()
                .reduce((acc, key) => {
                    acc[key] = value[key];
                    return acc;
                }, {}),
        );
    }
    return String(value);
};

export function buildRiskRequestKey(parts = []) {
    if (!Array.isArray(parts)) {
        return '';
    }
    return parts.map(normalizeKeyPart).join('|');
}

export function runInFlightRequest(key, fn) {
    if (typeof fn !== 'function') {
        return Promise.resolve(undefined);
    }
    if (key == null || key === '') {
        return Promise.resolve().then(() => fn());
    }

    const requestKey = String(key);
    const existing = inFlightRequests.get(requestKey);
    if (existing) {
        return existing;
    }

    let promise;
    try {
        promise = Promise.resolve(fn());
    } catch (err) {
        return Promise.reject(err);
    }

    inFlightRequests.set(requestKey, promise);
    const clearIfCurrent = () => {
        if (inFlightRequests.get(requestKey) === promise) {
            inFlightRequests.delete(requestKey);
        }
    };
    promise.then(clearIfCurrent, clearIfCurrent);
    return promise;
}

export function clearInFlightRequestsForTest() {
    inFlightRequests.clear();
}
